/** Starlink: the terminals, a site's and an event's cards, the business account — English, the source of the other languages */
const starlink = {
  "starlink.title": "Starlink terminals",
  "starlink.subtitle": "The company's Starlink terminals: their site or event, online, data used and their service",
  "starlink.search": "Search Starlink terminals",
  "starlink.refresh": "Refresh",
  "starlink.refreshed": "Starlink accounts read",
  "starlink.refreshFailed": "The Starlink accounts were not read",
  "starlink.addByKit": "Add by kit serial",
  "starlink.addHint": "A terminal on a personal plan, without a business account: it shows what Velanox knows of it — its site and its rental item.",
  "starlink.kitSerial": "Kit serial",
  "starlink.nickname": "Name (optional)",
  "starlink.add": "Add",
  "starlink.added": "Starlink added",
  "starlink.addFailed": "Starlink not added",
  "starlink.none": "No Starlink terminals yet. Add the company's business account under Company settings → Connections, or add a terminal by its kit serial.",
  "starlink.col.terminal": "Terminal",
  "starlink.col.site": "Site or event",
  "starlink.col.online": "Online",
  "starlink.col.data": "Data",
  "starlink.col.service": "Service",
  "starlink.online": "Online",
  "starlink.offline": "Offline",
  "starlink.lastRead": "Last read {when}",
  "starlink.notRead": "Not read yet",
  "starlink.noAccount": "No account",
  "starlink.notListed": "No longer in its account",
  "starlink.data": "{used} of {plan} GB",
  "starlink.dataNoLimit": "{used} GB",
  "starlink.serviceOn": "On",
  "starlink.serviceOff": "Off",
  "starlink.serviceUnknown": "Unknown",
  "starlink.switching": "Switching…",
  "starlink.event": "Event: {name}",
  "starlink.linkToSite": "Link to site",
  "starlink.site": "Site",
  "starlink.noSite": "No site",
  "starlink.linked": "Starlink linked",
  "starlink.linkFailed": "Starlink not linked",
  "starlink.save": "Save",
  "starlink.remove": "Remove",
  "starlink.removeConfirm": "Remove {name}? One still in its account comes back at the next read, on no site.",
  "starlink.removed": "Starlink removed",
  "starlink.removeFailed": "Starlink not removed",
  "starlink.card.lastSeen": "Last seen {when}",
  "starlink.card.neverSeen": "Never heard from",
  "starlink.card.alerts": "The dish reports: {alerts}",
  "starlink.card.data": "Data this billing cycle",
  "starlink.card.noLimit": "Its plan has no data limit",
  "starlink.card.noData": "No data use known",
  "starlink.card.service": "Service",
  "starlink.card.onConfirm": "Switch this Starlink's service on? It may be charged.",
  "starlink.card.offConfirm": "Switch this Starlink's service off?",
  "starlink.card.switched": "Service switched",
  "starlink.card.switchFailed": "Service not switched",
  "starlink.card.inApp": "Switch it in the Starlink app: its plan cannot be paused from here.",
  "starlink.card.pending": "Starlink has not taken the switch yet: it is tried again every 5 minutes.",
  "starlink.card.noAccount": "No business account: use the Starlink app for its data use and its service.",
  "starlink.eventCard.none": "No Starlink terminals on this event.",
  "starlink.eventCard.switchedOn": "Switched on",
  "starlink.eventCard.switchedOff": "Switched off",
  "starlink.eventCard.notTaken": "not taken by Starlink",
  "starlink.eventCard.withEvent": "with the event",
  "starlink.eventCard.by": "by {name}",
  "starlink.eventCard.noSwitches": "Not switched for this event yet",
  "starlink.account.title": "Starlink business account",
  "starlink.account.intro": "The client ID and secret of a service account of the company's Starlink business account. Velanox reads its terminals every 5 minutes and switches their service with your events.",
  "starlink.account.name": "Name",
  "starlink.account.clientId": "Client ID",
  "starlink.account.clientSecret": "Client secret",
  "starlink.account.secretKept": "Leave empty to keep the secret",
  "starlink.account.save": "Test and save",
  "starlink.account.saved": "Starlink account saved",
  "starlink.account.terminals": "Terminals",
  "starlink.edit": "Edit",
  "starlink.saved": "Starlink saved",
  "starlink.saveFailed": "Starlink not saved",
  "starlink.dish.title": "Starlink dish",
  "starlink.dish.auto": "Automatic",
  "starlink.dish.wan": "Only {wan}",
  "starlink.dish.off": "Off",
  "starlink.dish.lookAgain": "Look again",
  "starlink.dish.looking": "Looking…",
  "starlink.dish.found": "Found on {wan}",
  "starlink.dish.notFound": "No Starlink found behind this router",
  "starlink.dish.failed": "Rules could not be written: {reason}",
  "starlink.dish.turnedOff": "Velanox does not look for a Starlink dish behind this router",
  "starlink.dish.notChanged": "The Starlink dish setting was not changed",
  "starlink.dish.block": "Dish",
  "starlink.dish.signalOk": "Signal good",
  "starlink.dish.signalLow": "Signal weak",
  "starlink.dish.obstructed": "Obstructed {pct}%",
  "starlink.dish.obstructedNow": "obstructed now",
  "starlink.dish.speed": "Down {down} · Up {up} Mbps",
  "starlink.dish.latency": "Latency {ms} ms",
  "starlink.dish.drop": "{pct}% of pings dropped",
  "starlink.dish.stowed": "Stowed",
  "starlink.dish.reachedVia": "Reached through {site}",
  "starlink.dish.notReachedSince": "Not reached since {when}",
  "starlink.dish.notReached": "Not reached",
  "starlink.dish.reboot": "Reboot",
  "starlink.dish.stow": "Stow",
  "starlink.dish.unstow": "Unstow",
  "starlink.dish.rebootConfirm": "Reboot this dish? Its connection drops for a few minutes.",
  "starlink.dish.stowConfirm": "Stow this dish? It folds flat and its connection stops.",
  "starlink.dish.unstowConfirm": "Unstow this dish?",
  "starlink.dish.done": "Sent to the dish",
  "starlink.dish.actionFailed": "The dish did not do it",
}

export default starlink
